import styled from 'styled-components'

const StyleWrapper = styled.div.attrs({
    className: "weui-tabbar weui-tabbar__fixed footer-fixed"
})`

`
export default StyleWrapper


// WEBPACK FOOTER //
// ./src/components/Footer/StyleWrapper.js


// WEBPACK FOOTER //
// ./src/components/Footer/StyleWrapper.js